import apiClient from './index';
import { MobileRegistrationStatsResponse } from './types';

export const mobileStatsApi = {
  async getRegistrationStats(
    limit = 10,
    offset = 0,
    dailyDays = 30
  ): Promise<MobileRegistrationStatsResponse> {
    const res = await apiClient.get<MobileRegistrationStatsResponse>(
      '/admin/mobile/registrations/stats',
      { params: { limit, offset, daily_days: dailyDays } }
    );
    return res.data;
  },
};
